/**
 * @generated SignedSource<<ea49052951f377c360715ea6a4cc7bdf>>
 * @relayHash 08356da0dcdf728974572b8fd470cb17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22391a6351810c59f5b7faf4f4b111fb3fbe055924c265a793c30d9a80107090

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainIssueAGSQuery$variables = {
  cloudId: string;
  first: number;
  jqlSearch: string;
};
export type mainIssueAGSQuery$data = {
  readonly jira: {
    readonly issueSearchStable: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldsByIdOrAlias: ReadonlyArray<{
            readonly fieldId?: string;
            readonly issueType?: {
              readonly id: string;
            } | null | undefined;
            readonly parentIssue?: {
              readonly fieldsByIdOrAlias: ReadonlyArray<{
                readonly fieldId?: string;
                readonly text?: string | null | undefined;
              } | null | undefined> | null | undefined;
              readonly id: string;
              readonly issueColorField: {
                readonly color: {
                  readonly colorKey: string | null | undefined;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly text?: string | null | undefined;
            readonly user?: {
              readonly __typename: string;
              readonly accountId: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly id: string;
          readonly key: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type mainIssueAGSQuery = {
  response: mainIssueAGSQuery$data;
  variables: mainIssueAGSQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlSearch"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "jql",
        "variableName": "jqlSearch"
      }
    ],
    "kind": "ObjectValue",
    "name": "issueSearchInput"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = [
  {
    "kind": "Literal",
    "name": "idsOrAliases",
    "value": [
      "issuetype",
      "assignee",
      "parent",
      "summary"
    ]
  },
  {
    "kind": "Literal",
    "name": "ignoreMissingFields",
    "value": true
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
},
v14 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v15 = [
  {
    "kind": "Literal",
    "name": "idsOrAliases",
    "value": [
      "summary"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainIssueAGSQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearchStable",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "args": (v6/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "JiraColorField",
                                    "kind": "LinkedField",
                                    "name": "issueColorField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "args": (v15/*: any*/),
                                    "kind": "LinkedField",
                                    "name": "fieldsByIdOrAlias",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\"])"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraParentIssueField"
                          }
                        ],
                        "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"assignee\",\"parent\",\"summary\"],ignoreMissingFields:true)"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainIssueAGSQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearchStable",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "args": (v6/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v4/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "JiraColorField",
                                    "kind": "LinkedField",
                                    "name": "issueColorField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v4/*: any*/)
                                        ]
                                      },
                                      (v4/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": (v15/*: any*/),
                                    "kind": "LinkedField",
                                    "name": "fieldsByIdOrAlias",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\"])"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraParentIssueField"
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"assignee\",\"parent\",\"summary\"],ignoreMissingFields:true)"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "22391a6351810c59f5b7faf4f4b111fb3fbe055924c265a793c30d9a80107090",
    "metadata": {},
    "name": "mainIssueAGSQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b88c5eb28196cc550fa42480e3096026";

export default node;
